module.exports = {
  "active-listener": "0 0 16 16",
  "add-item": "0 0 16 16",
  "add-keyword": "0 0 16 16",
  "add-team-member": "0 0 18 13",
  "add-variable": "0 0 18 14",
  "address-card-outline": "0 0 16 16",
  "address-card-solid": "0 0 18 16",
  "adobe-experience-manager": "0 0 16 18",
  "ads": "0 0 9 16",
  "advocacy-outline": "0 0 14 16",
  "advocacy": "0 0 14 16",
  "android": "0 0 14 16",
  "apple": "0 0 14 16",
  "approval-indicator-outline": "0 0 14 16",
  "approval-indicator": "0 0 14 16",
  "archive": "0 0 16 16",
  "arrow-down-line": "0 0 14 16",
  "arrow-down": "0 0 16 16",
  "arrow-left-line": "0 0 16 18",
  "arrow-left": "0 0 16 16",
  "arrow-right-line": "0 0 16 18",
  "arrow-right": "0 0 16 16",
  "arrow-up-line": "0 0 14 16",
  "arrow-up": "0 0 16 16",
  "arrows": "0 0 16 16",
  "asset-library-outline": "0 0 16 16",
  "asset-library": "0 0 16 16",
  "assign": "0 0 18 15",
  "atom": "0 0 14 16",
  "audio": "0 0 16 14",
  "back-to-top": "0 0 15 16",
  "bambu-icon-outline": "0 0 16 16",
  "bambu-icon": "0 0 16 16",
  "barcode": "0 0 18 16",
  "basketball": "0 0 16 16",
  "bell-outline": "0 0 14 16",
  "bigcommerce": "0 0 16 16",
  "bitly": "0 0 16 16",
  "bold": "0 0 16 16",
  "book": "0 0 14 16",
  "bookmark": "0 0 12 16",
  "bot": "0 0 16 16",
  "browser": "0 0 16 16",
  "business": "0 0 16 16",
  "calendar-outline": "0 0 14 16",
  "calendar": "0 0 14 16",
  "camera-outline": "0 0 18 16",
  "camera-story": "0 0 18 16",
  "camera": "0 0 18 16",
  "campaign": "0 0 16 14",
  "canva": "0 0 16 18",
  "carousel": "0 0 16 18",
  "cart-plus-outline": "0 0 17 15",
  "cart-plus": "0 0 17 15",
  "check": "0 0 16 16",
  "chevron-down-filled": "0 0 16 21",
  "chevron-down": "0 0 16 18",
  "chevron-left": "0 0 10 16",
  "chevron-right": "0 0 10 17",
  "chevron-up-down-filled": "0 0 12 20",
  "chevron-up-filled": "0 0 16 21",
  "chevron-up": "0 0 16 18",
  "circle-check-outline": "0 0 16 16",
  "circle-check": "0 0 16 16",
  "circle": "0 0 16 16",
  "circle+": "0 0 16 16",
  "circles": "0 0 16 16",
  "circlex": "0 0 16 16",
  "click-to-view": "0 0 12 16",
  "clicks": "0 0 10 16",
  "clipboard-outline": "0 0 12 16",
  "clipboard": "0 0 12 16",
  "clock": "0 0 16 16",
  "closed-captioning": "0 0 16 16",
  "cloud": "0 0 16 13",
  "code": "0 0 18 16",
  "columns": "0 0 16 16",
  "comment-ai-outline": "0 0 18 18",
  "comment-ai": "0 0 18 18",
  "comment-alt-outline": "0 0 16 15",
  "comment-alt": "0 0 16 15",
  "comment-lines-alt-outline": "0 0 16 16",
  "comment": "0 0 16 13",
  "compact-density": "0 0 16 16",
  "compact-indicator": "0 0 16 16",
  "comparison": "0 0 16 14",
  "competitor": "0 0 14 16",
  "compose": "0 0 16 16",
  "content-suggestions": "0 0 16 16",
  "credit-card": "0 0 16 14",
  "crop": "0 0 16 16",
  "crown": "0 0 16 16",
  "dashboard": "0 0 16 14",
  "deconstructed-negative-sentiment": "0 0 18 18",
  "deconstructed-neutral-sentiment": "0 0 18 18",
  "deconstructed-positive-sentiment": "0 0 18 18",
  "discovery": "0 0 16 16",
  "dislike-outline": "0 0 15 16",
  "dislike": "0 0 16 16",
  "dm-link-outline": "0 0 16 16",
  "dm-link": "0 0 16 16",
  "dotdotdot": "0 0 16 16",
  "download": "0 0 16 16",
  "drafts-outline": "0 0 12 16",
  "drafts": "0 0 12 16",
  "dropbox": "0 0 18 16",
  "duplicate-outline": "0 0 14 16",
  "duplicate": "0 0 14 16",
  "emoji-outline": "0 0 16 16",
  "emoji": "0 0 16 16",
  "empty-image": "0 0 16 18",
  "engagement-per-post": "0 0 16 16",
  "engagements": "0 0 16 15",
  "error": "0 0 16 16",
  "exchange-alt": "0 0 16 16",
  "expanded-indicator": "0 0 16 16",
  "export": "0 0 14 17",
  "extended-circles": "0 0 16 16",
  "external-link-alt": "0 0 16 16",
  "external-link": "0 0 16 16",
  "extreme-negative-sentiment": "0 0 16 16",
  "eye-outline": "0 0 18 16",
  "eye-slash-outline": "0 0 20 16",
  "eye-slash": "0 0 20 16",
  "eye": "0 0 18 16",
  "facebook-audience-network": "0 0 16 16",
  "facebook-branded-content-outline": "0 0 18 15",
  "facebook-branded-content": "0 0 18 15",
  "facebook-groups": "0 0 16 16",
  "facebook": "0 0 16 16",
  "fb-reactions-angry": "0 0 16 16",
  "fb-reactions-haha": "0 0 16 16",
  "fb-reactions-like": "0 0 16 16",
  "fb-reactions-love": "0 0 16 16",
  "fb-reactions-sad": "0 0 16 16",
  "fb-reactions-wow": "0 0 16 16",
  "feedly": "0 0 16 15",
  "feeds": "0 0 16 15",
  "female": "0 0 11 18",
  "file-chart-line": "0 0 12 16",
  "file-edit": "0 0 12 16",
  "file-times-solid": "0 0 12 16",
  "filter": "0 0 16 16",
  "flag-outline": "0 0 16 16",
  "flag": "0 0 16 16",
  "flat-negative-sentiment-outline": "0 0 18 18",
  "flat-negative-sentiment": "0 0 18 18",
  "flat-neutral-sentiment-outline": "0 0 18 18",
  "flat-neutral-sentiment": "0 0 18 18",
  "flat-positive-sentiment-outline": "0 0 18 18",
  "flat-positive-sentiment": "0 0 18 18",
  "folder-open": "0 0 16 15",
  "folder": "0 0 16 16",
  "follow-outline": "0 0 20 16",
  "follow": "0 0 20 16",
  "follower-increase": "0 0 19 16",
  "following": "0 0 20 16",
  "font": "0 0 18 16",
  "full-access": "0 0 16 16",
  "gear": "0 0 16 16",
  "gears": "0 0 16 16",
  "github": "0 0 18 18",
  "glassdoor": "0 0 16 16",
  "glasses": "0 0 18 14",
  "globe": "0 0 16 16",
  "google-analytics-color": "0 0 14 18",
  "google-business-messages": "0 0 16 16",
  "google-drive": "0 0 16 14",
  "google-my-business": "0 0 16 14",
  "grip": "0 0 8 18",
  "h1": "0 0 16 16",
  "h2": "0 0 16 16",
  "h3": "0 0 16 16",
  "h4": "0 0 16 16",
  "hamburger": "0 0 16 18",
  "hashtag": "0 0 16 16",
  "headset": "0 0 16 16",
  "heart-outline": "0 0 16 16",
  "heart": "0 0 16 16",
  "heartbeat": "0 0 18 16",
  "help-alt": "0 0 12 16",
  "help": "0 0 16 16",
  "hiking": "0 0 16 16",
  "history": "0 0 16 16",
  "home": "0 0 16 15",
  "hourglass": "0 0 12 16",
  "hubspot": "0 0 16 16",
  "image-caption": "0 0 16 14",
  "image": "0 0 16 16",
  "images": "0 0 16 15",
  "impressions-per-post": "0 0 16 16",
  "impressions": "0 0 18 16",
  "inactive-listener": "0 0 16 12",
  "inbox-action": "0 0 16 16",
  "inbox-views": "0 0 16 13",
  "inbox": "0 0 16 14",
  "indicator": "0 0 16 16",
  "industry": "0 0 14 16",
  "info": "0 0 16 16",
  "instagram": "0 0 16 16",
  "internal-activity-outline": "0 0 16 16",
  "internal-activity": "0 0 16 16",
  "italic": "0 0 16 16",
  "key": "0 0 16 16",
  "keyboard": "0 0 18 16",
  "laptop-phone": "0 0 16 16",
  "large-density": "0 0 16 16",
  "lift": "0 0 23 16",
  "like-outline": "0 0 15 16",
  "like": "0 0 16 16",
  "link": "0 0 16 16",
  "linkedin-audience-network": "0 0 16 16",
  "linkedin": "0 0 16 16",
  "list-ol": "0 0 16 16",
  "listening": "0 0 14 16",
  "lists": "0 0 16 16",
  "location-outline": "0 0 12 16",
  "location": "0 0 12 16",
  "lock": "0 0 14 16",
  "magic-wand": "0 0 17 16",
  "male": "0 0 16 20",
  "marketo": "0 0 16 18",
  "mention": "0 0 16 16",
  "message-preview-outline": "0 0 18 16",
  "message-preview": "0 0 18 16",
  "message": "0 0 16 16",
  "messages-outline": "0 0 16 16",
  "messages": "0 0 16 16",
  "messenger": "0 0 16 16",
  "metric-table": "0 0 16 16",
  "microsoft-dynamics": "0 0 16 16",
  "minus": "0 0 16 16",
  "mobile": "0 0 10 16",
  "monitor": "0 0 12 16",
  "moon": "0 0 15 16",
  "negative-sentiment": "0 0 16 16",
  "neutral-positive-sentiment": "0 0 16 16",
  "neutral-sentiment": "0 0 16 16",
  "new-trend": "0 0 12 16",
  "newspaper": "0 0 16 16",
  "no-access": "0 0 16 16",
  "notepad": "0 0 12 16",
  "notifications-publishing-outline": "0 0 16 16",
  "notifications-publishing": "0 0 16 16",
  "notifications": "0 0 14 16",
  "offline": "0 0 18 15",
  "online": "0 0 18 15",
  "paid-promotion-outline": "0 0 16 16",
  "paid-promotion": "0 0 16 16",
  "paid": "0 0 14 16",
  "paint": "0 0 18 16",
  "palette": "0 0 16 16",
  "paperclip": "0 0 14 16",
  "pause": "0 0 16 18",
  "pencil-outline": "0 0 16 16",
  "pencil": "0 0 16 16",
  "person": "0 0 14 16",
  "phone": "0 0 16 16",
  "pinterest-boards-outline": "0 0 14 16",
  "pinterest-boards": "0 0 14 16",
  "pinterest": "0 0 16 16",
  "play-circle": "0 0 16 16",
  "play": "0 0 14 16",
  "plug": "0 0 12 16",
  "plus": "0 0 16 18",
  "positive-sentiment": "0 0 16 16",
  "power-up-outline": "0 0 12 16",
  "power-up": "0 0 10 16",
  "profile-connect": "0 0 16 16",
  "profile-disconnect": "0 0 16 16",
  "publishing-outline": "0 0 16 16",
  "publishing": "0 0 16 16",
  "puzzle-piece": "0 0 18 16",
  "qr-code": "0 0 16 16",
  "queue": "0 0 16 16",
  "recommendation": "0 0 16 16",
  "reddit-alien": "0 0 16 16",
  "reddit": "0 0 16 16",
  "reels-outline": "0 0 16 16",
  "reels": "0 0 16 16",
  "referrals": "0 0 16 16",
  "refresh": "0 0 16 16",
  "rejected": "0 0 16 16",
  "reply-outline": "0 0 16 16",
  "reply": "0 0 16 16",
  "reporting-period": "0 0 14 16",
  "reporting": "0 0 16 16",
  "reports-home": "0 0 16 16",
  "reports": "0 0 16 15",
  "retweet": "0 0 18 16",
  "route": "0 0 18 18",
  "rss": "0 0 16 16",
  "sales": "0 0 9 16",
  "salesforce-cloud": "0 0 20 16",
  "salesforce": "0 0 20 16",
  "save-assets": "0 0 16 16",
  "saved-messages": "0 0 16 16",
  "saved-reply-outline": "0 0 16 12",
  "saved-reply": "0 0 16 12",
  "search": "0 0 16 16",
  "send-again-outline": "0 0 18 18",
  "send-again": "0 0 18 18",
  "sent-message-outline": "0 0 16 14",
  "sent-message": "0 0 16 14",
  "share": "0 0 16 14",
  "shopify": "0 0 16 18",
  "shopping-bag-outline": "0 0 14 16",
  "shopping-bag": "0 0 14 16",
  "show-navigation": "0 0 18 14",
  "slack": "0 0 16 16",
  "small-density": "0 0 16 16",
  "smiley": "0 0 16 16",
  "some-access": "0 0 16 16",
  "sparkles": "0 0 16 16",
  "spike-alert": "0 0 16 16",
  "star-half-alt-solid": "0 0 18 16",
  "star-of-life": "0 0 16 16",
  "star-outline": "0 0 18 16",
  "star": "0 0 18 16",
  "sticky-note-outline": "0 0 16 16",
  "sticky-note": "0 0 16 16",
  "stories": "0 0 16 17",
  "story": "0 0 16 16",
  "suggestions": "0 0 11 16",
  "sun": "0 0 16 16",
  "tag-outline": "0 0 16 16",
  "tag": "0 0 16 16",
  "targeting-outline": "0 0 16 16",
  "targeting": "0 0 16 16",
  "tasks-check": "0 0 16 16",
  "tasks-outline": "0 0 12 16",
  "tasks": "0 0 12 16",
  "team-conversation-outline": "0 0 16 18",
  "team-conversation": "0 0 16 18",
  "team-sprout-outline": "0 0 18 18",
  "team-sprout": "0 0 18 18",
  "team": "0 0 18 16",
  "text-asset": "0 0 16 16",
  "text": "0 0 8 16",
  "tiktok": "0 0 16 18",
  "times": "0 0 16 22",
  "tools": "0 0 67 67",
  "trash-can-outline": "0 0 14 16",
  "trash-can": "0 0 14 16",
  "trend-down": "0 0 18 18",
  "trend-neutral": "0 0 20 18",
  "trend-up": "0 0 18 18",
  "trends": "0 0 16 17",
  "triangle-black": "0 0 16 16",
  "triangle": "0 0 16 16",
  "tripadvisor-circle-outline": "0 0 16 16",
  "tripadvisor-circle": "0 0 16 16",
  "tripadvisor": "0 0 16 16",
  "trophy-outline": "0 0 18 16",
  "tumblr": "0 0 16 16",
  "twitter-audience-network": "0 0 17 16",
  "twitter": "0 0 17 16",
  "underline": "0 0 14 16",
  "unfollow-outline": "0 0 20 16",
  "unfollow": "0 0 20 16",
  "unlink": "0 0 16 16",
  "unlock": "0 0 14 16",
  "upload": "0 0 16 17",
  "user-circle": "0 0 16 16",
  "users": "0 0 18 16",
  "verified": "0 0 16 16",
  "video-camera-story": "0 0 18 15",
  "video-camera": "0 0 18 16",
  "vip": "0 0 16 16",
  "weight": "0 0 16 16",
  "whatsapp": "0 0 16 16",
  "window-maximize": "0 0 16 16",
  "window-minimize": "0 0 16 16",
  "window-regular": "0 0 16 16",
  "window-restore": "0 0 16 16",
  "woocommerce": "0 0 18 16",
  "x": "0 0 16 18",
  "yelp-full-star": "0 0 16 16",
  "yelp-half-star": "0 0 16 16",
  "yelp": "0 0 14 16",
  "youtube": "0 0 16 15",
  "zendesk": "0 0 16 16"
};